import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a6458d7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "permission-tabs"
};
const _hoisted_2 = {
  key: 0,
  class: "tab-children"
};
const _hoisted_3 = {
  key: 0,
  class: "level-2-children"
};
const _hoisted_4 = {
  class: "permission-row"
};
const _hoisted_5 = {
  key: 0,
  class: "child-permissions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_checkbox = _resolveComponent("a-checkbox");
  const _component_permission_tree = _resolveComponent("permission-tree", true);
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["resource-tree", 'level-' + _ctx.level])
  }, [_ctx.level === 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.resources, resource => {
    return _openBlock(), _createElementBlock("div", {
      key: resource.permissionId,
      class: "permission-item"
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
      class: _normalizeClass(["tab-item main-tab", {
        active: _ctx.isPermissionChecked(resource.permissionId)
      }])
    }, [_createVNode(_component_a_checkbox, {
      indeterminate: _ctx.isPermissionIndeterminate(resource.permissionId),
      checked: _ctx.isPermissionChecked(resource.permissionId),
      disabled: !_ctx.isEditMode,
      onChange: e => _ctx.handlePermissionChange(resource.permissionId, e.target.checked)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(resource.name), 1)]),
      _: 2
    }, 1032, ["indeterminate", "checked", "disabled", "onChange"])], 2), resource.children && resource.children.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource.children, child => {
      return _openBlock(), _createElementBlock("div", {
        key: child.permissionId,
        class: _normalizeClass(["tab-item child-tab", {
          active: _ctx.isPermissionChecked(child.permissionId)
        }])
      }, [_createVNode(_component_a_checkbox, {
        checked: _ctx.isPermissionChecked(child.permissionId),
        indeterminate: _ctx.isPermissionIndeterminate(child.permissionId),
        disabled: !_ctx.isEditMode,
        onChange: e => _ctx.handlePermissionChange(child.permissionId, e.target.checked)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(child.name), 1)]),
        _: 2
      }, 1032, ["checked", "indeterminate", "disabled", "onChange"])], 2);
    }), 128))])) : _createCommentVNode("", true)]), resource.children && resource.children.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource.children, child => {
      return _openBlock(), _createElementBlock("div", {
        key: child.permissionId,
        class: "level-2-child-container"
      }, [child.children && child.children.length > 0 ? (_openBlock(), _createBlock(_component_permission_tree, {
        key: 0,
        resources: [child],
        "selected-permissions": _ctx.selectedPermissions,
        "is-edit-mode": _ctx.isEditMode,
        level: 3,
        onChange: _ctx.onChildChange,
        class: "nested-permission"
      }, null, 8, ["resources", "selected-permissions", "is-edit-mode", "onChange"])) : _createCommentVNode("", true)]);
    }), 128))])) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true), _ctx.level >= 3 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList(_ctx.resources, resource => {
    return _openBlock(), _createElementBlock("div", {
      key: resource.permissionId,
      class: "permission-item"
    }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_checkbox, {
      checked: _ctx.isPermissionChecked(resource.permissionId),
      indeterminate: _ctx.isPermissionIndeterminate(resource.permissionId),
      disabled: !_ctx.isEditMode,
      onChange: e => _ctx.handlePermissionChange(resource.permissionId, e.target.checked)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(resource.name), 1)]),
      _: 2
    }, 1032, ["checked", "indeterminate", "disabled", "onChange"]), _ctx.level === 3 && resource.children && resource.children.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource.children, child => {
      return _openBlock(), _createElementBlock("div", {
        key: child.permissionId,
        class: "child-permission-item"
      }, [_createVNode(_component_a_checkbox, {
        checked: _ctx.isPermissionChecked(child.permissionId),
        indeterminate: _ctx.isPermissionIndeterminate(child.permissionId),
        disabled: !_ctx.isEditMode,
        onChange: e => _ctx.handlePermissionChange(child.permissionId, e.target.checked)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(child.name), 1)]),
        _: 2
      }, 1032, ["checked", "indeterminate", "disabled", "onChange"])]);
    }), 128))])) : _createCommentVNode("", true)]), _ctx.level > 3 && resource.children && resource.children.length > 0 ? (_openBlock(), _createBlock(_component_permission_tree, {
      key: 0,
      resources: resource.children,
      "selected-permissions": _ctx.selectedPermissions,
      "is-edit-mode": _ctx.isEditMode,
      level: _ctx.level + 1,
      onChange: _ctx.onChildChange,
      class: "nested-permission"
    }, null, 8, ["resources", "selected-permissions", "is-edit-mode", "level", "onChange"])) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true)], 2);
}